
<template>
    <div class="navbar-before mobile-hidden">
        <div class="container">
            <div class="row">
                <!-- <div class="col-md-6">
                    <p class="navbar-before-sign">Everything You Need is Toolaku</p>
                </div> -->
                <div class="col-sm-5">
                    <!-- <ul class="nav navbar-nav navbar-right navbar-right-no-mar"> -->
                    <ul class="nav navbar-nav navbar-left navbar-nav-no-padding">
                        <li>
                            <router-link to="/aboutUs">
                                <a href="#" style="color: #ffffff">About Us</a>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/contactUs">
                                <a href="#" style="color: #ffffff">Contact Us</a>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/FAQ">
                                <a href="#" style="color: #ffffff">Help/FAQ </a>
                            </router-link>
                        </li>
                        <!-- <li>
                            <router-link to="/Help">
                                <a href="#" style="color: #ffffff">Help</a>
                            </router-link>
                        </li> -->
                    </ul>
                </div>
                <div class="col-sm-7 navbar-right text-right" v-if="currentUser">
                    <span style="color: #ffffff">Welcome {{currentUser.name}}</span>
                </div>
                <!--<div class="col-md-6">
                    <ul class="nav navbar-nav navbar-right">
                        <li>
                            <a v-bind:href="dashboardUrl" target="_blank">Dashboard</a>
                        </li>
                        <li v-if="!isAuthenticated">
                            <a href="#nav-login-dialog" data-effect="mfp-move-from-top" class="popup-text">Sign In</a>
                        </li>
                        <li v-if="!isAuthenticated">
                            <a href="#nav-account-dialog" data-effect="mfp-move-from-top" class="popup-text">Register</a>
                        </li>
                        <li v-if="isAuthenticated">
                            <a href="#" data-effect="mfp-move-from-top" class="popup-text">{{currentUser.name}}</a>
                        </li>
                        <li v-if="isAuthenticated">
                            <a href="" @click="singOut">Sign out</a>
                        </li>
                    </ul>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapGetters  } from 'vuex'

export default {

  computed: {
    ...mapGetters('user', ['isAuthenticated', 'currentUser']),
  },

}
</script>

